export const wrapperIdentifier = 'inAppBrowser';
